import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const TransactionBi = () => {
  // Sample transaction statistics
  const transactionStats = [
    {
      title: 'Total Transactions',
      value: '45,678',
      change: '+12.5%',
      changeType: 'positive',
      icon: 'bi bi-receipt',
      color: 'primary'
    },
    {
      title: 'Success Rate',
      value: '94.3%',
      change: '+2.1%',
      changeType: 'positive',
      icon: 'bi bi-check-circle',
      color: 'success'
    },
    {
      title: 'Failed Transactions',
      value: '2,345',
      change: '-5.2%',
      changeType: 'positive',
      icon: 'bi bi-x-circle',
      color: 'danger'
    },
    {
      title: 'Pending Transactions',
      value: '1,234',
      change: '-8.3%',
      changeType: 'positive',
      icon: 'bi bi-hourglass-split',
      color: 'warning'
    }
  ];

  const recentTransactions = [
    { type: 'Recharge', amount: '₹1,234', status: 'Success', time: '2 mins ago' },
    { type: 'Bill Payment', amount: '₹5,678', status: 'Success', time: '5 mins ago' },
    { type: 'Money Transfer', amount: '₹25,000', status: 'Pending', time: '10 mins ago' },
    { type: 'AEPS', amount: '₹2,500', status: 'Success', time: '15 mins ago' },
    { type: 'DMT', amount: '₹50,000', status: 'Failed', time: '20 mins ago' }
  ];

  return (
    <Container fluid className="">
      {/* Page Header */}
      <div className="mb-4">
        <h4 className="mb-1" style={{ color: '#1e293b', fontWeight: '700', fontSize: '1.5rem' }}>
          Transaction Business Intelligence
        </h4>
        <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
          Real-time transaction analytics and insights
        </p>
      </div>

      {/* Statistics Cards */}
      <Row className="mb-4">
        {transactionStats.map((stat, index) => (
          <Col key={index} xs={12} sm={6} lg={3} className="mb-3">
            <Card className="border-0 shadow-sm h-100">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div className={`text-${stat.color}`}>
                    <i className={`${stat.icon} fs-2`}></i>
                  </div>
                  <span className={`badge bg-${stat.changeType === 'positive' ? 'success' : 'danger'}`}>
                    {stat.change}
                  </span>
                </div>
                <h3 className="mb-1" style={{ color: '#1e293b', fontWeight: '700' }}>
                  {stat.value}
                </h3>
                <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>
                  {stat.title}
                </p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Recent Transactions */}
      <Row>
        <Col lg={8} className="mb-4">
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <h5 className="mb-4" style={{ fontWeight: '700', color: '#1e293b' }}>
                Transaction Trends
              </h5>
              <div className="text-center py-5">
                <i className="bi bi-graph-up fs-1 text-muted mb-3 d-block"></i>
                <p className="text-muted">Transaction trend chart will be displayed here</p>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} className="mb-4">
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <h5 className="mb-4" style={{ fontWeight: '700', color: '#1e293b' }}>
                Recent Activity
              </h5>
              <div className="recent-transactions">
                {recentTransactions.map((txn, index) => (
                  <div key={index} className="d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom">
                    <div>
                      <h6 className="mb-1" style={{ fontSize: '0.875rem', fontWeight: '600' }}>
                        {txn.type}
                      </h6>
                      <small className="text-muted">{txn.time}</small>
                    </div>
                    <div className="text-end">
                      <div className="fw-bold mb-1">{txn.amount}</div>
                      <span className={`badge bg-${
                        txn.status === 'Success' ? 'success' : 
                        txn.status === 'Pending' ? 'warning' : 'danger'
                      }`} style={{ fontSize: '0.7rem' }}>
                        {txn.status}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default TransactionBi;

